<template>
  <div>
      <div class="bodyWrap">
          <header>
              <div class="headTop">
                  <div class="topBox">
                       <div class="headLeft fl">
                        <span>时间：2021年3月31日</span>
                        <span>星期三</span>
                      </div>
                      <div class="headRig fr">
                  <router-link  to="/login" tag="span">登录</router-link>
                           <router-link to="/register" tag="span">注册</router-link>
                      </div>
                  </div>
              </div>
              <div class="headBottom">
                 <div class="bottomBox">
                    <div class="botLeft fl">
                    <img src="../../assets/img/show/logo.png" alt="">
                  </div>
                  <div class="botdRig fr">
                    <ul class="fl headUl">
                      <li>资源管理</li>
                      <li>统计分析</li>
                      <li>返回信息网</li>
                    </ul>
                    <div class="fr headSearch">
                          <el-input v-model="input" placeholder="发现数据从这里开始"></el-input>
                          <span>
                              <img src="../../assets/img/show/search.png" alt="">
                          </span>
                    </div>
                  </div>
                 </div>
              </div>
          </header>
          <div class="banner"> 
                <img src="../../assets/img/show/banner.png" alt="">
          </div>
          <div class="main">
            <div class="title">
                 <p>当前位置：首页 > 种质圃（库）</p>
            </div>
            <div class="tabZujian">
            <el-tabs v-model="activeName">
                <el-tab-pane label="种质圃" name="first" :key="'first'">
                    <ul class="list">
                   <li>
                         <img src="../../assets/img/show/img1.png" alt="">
                          <p>热带蔬菜种质圃</p>
                      </li>
                      <li>
                         <img src="../../assets/img/show/img2.png" alt="">
                          <p>热带牧草种质圃</p>
                      </li>
                      <li>
                         <img src="../../assets/img/show/img3.png" alt="">
                          <p>热带花卉种质圃</p>
                      </li>
                      <li>
                         <img src="../../assets/img/show/img4.png" alt="">
                          <p>南药种质圃</p>
                      </li>
                      <li>
                         <img src="../../assets/img/show/img5.png" alt="">
                          <p>木薯种质圃</p>
                      </li>
                      <li>
                         <img src="../../assets/img/show/img6.png" alt="">
                          <p>龙眼种质圃</p>
                      </li>
                    </ul>
                </el-tab-pane>
        
                <el-tab-pane label="种质库" name="second" :key="'second'">
                    <ul class="list">
                      <li>
                         <img src="../../assets/img/show/img1.png" alt="">
                          <p>热带蔬菜种质圃</p>
                      </li>
                      <li>
                         <img src="../../assets/img/show/img2.png" alt="">
                          <p>热带牧草种质圃</p>
                      </li>
                      <li>
                         <img src="../../assets/img/show/img3.png" alt="">
                          <p>热带花卉种质圃</p>
                      </li>
                      <li>
                         <img src="../../assets/img/show/img4.png" alt="">
                          <p>南药种质圃</p>
                      </li>
                      <li>
                         <img src="../../assets/img/show/img5.png" alt="">
                          <p>木薯种质圃</p>
                      </li>
                      <li>
                         <img src="../../assets/img/show/img6.png" alt="">
                          <p>龙眼种质圃</p>
                      </li>
                    </ul>
                </el-tab-pane>
              </el-tabs>
          </div>
          </div>
           
    <footer>
         <p>主持单位:中国热带农业科学院热带作物品种资源研究所 | 版权所有©热带作物种质资源信息网</p>
    </footer>
      </div>
  </div>
</template>
<script>
export default {
  name: "zzpList",
  data() {
    return {
     input: '',
     //默认第一个选项卡
            activeName: "first",
    };
  },
  methods: {
  

  },
};
</script>
<style scoped>
@import "../../assets/scss/show.css";
  .bodyWrap{
    width:100%;
    margin:0 auto;
    background: #eeeeee;
  }
  .main{
     width: 1200px;
     margin: 0 auto;
  }
  .title{
    padding:27px 0 20px 0;
  }
  .title p{
    font-size: 12px;
    color: #666666;
  }
  .botdRig {
    margin-right: 45px;
  }
  .banner img{
    height: 150px;
    display: block;
    width: 100%;
  }
  footer{
    height: 84px;
    line-height: 84px;
    background: #4a4e53;
    margin-top: 66px;
    text-align: center;
  }
  footer p{
    font-size: 14px;
    color: #fff;
  }
  .list{
    margin-top: 33px;
  }
  .list li{
    border: 1px solid #d1d1d1;
    width: 358px;
    margin-right: 55px;
    display: inline-block;
    margin-bottom: 38px;
    
  }
  .list li img{
    width: 100%;
    height: 226px;
  }
  .list li:nth-of-type(3){
    margin-right: 0;
  }
  .list li:nth-of-type(6){
    margin-right: 0;
  }
  .list li p{
    height: 56px;
    line-height: 53px;
    text-align: center;
    font-size: 18px;
    color: #333333;
    background: #fff;
  }
.el-tabs__item{
    font-size: 20px;
    color:#02874a;
  }
  .bottomBox{
    width: 1200px;
     margin: 0 auto;
  }
  .headBottom{
    background:#fff;
    height: 100px;
     
  }
  .headSearch{
    height: 40px;
    margin-top: 30px;
    position: relative;
  }
  .headSearch span{
        background: #02874a;
    position: absolute;
    right: -45px;
    top: 0;
    height: 38px;
    width: 51px;
    border: 1px solid #02874a;
    border-top-right-radius: 5px;
    border-left: 0;
    border-bottom-right-radius: 5px;
  }
  .headSearch span img{
    margin: 0 auto;
    text-align: center;
    display: block;
    margin-top: 7px;
    height: 24px;
  }
  .botLeft img{
   width: 489px;
   height: 42px;
   display: block;
   margin-top:29px;
  }
  .headUl li{
    font-size: 16px;
    color: #333333;
    display: inline-block;
    float: left;
    margin-right: 40px;
    line-height: 100px;
  }
  .topBox{
      width: 1200px;
       margin: 0 auto;
  }
  .headTop{
    background:#f1f1f1;
    height: 30px;
    line-height: 28px;
  }
  .el-input__inner{
    border: 1px solid #02874a !important;
    font-size: 14px;
  }
  .headLeft span{
    font-size: 12px;
    color: #666666;
    display: inline-block;
    margin-right: 30px;
  }
  .headRig span{
    font-size: 12px;
    color: #666666;
    margin-left: 30px;
     display: inline-block;
  }
</style>
